export function tokenGetter() {
  return typeof localStorage != 'undefined' ? localStorage.getItem('token') : null;
}
